/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A16Inputs */

const et_faq_a16 = /** @type {(inputs: Faq_A16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konversiooni optimeerimine (CRO) on protsess, mille eesmärk on muuta rohkem kodulehe külastajaid makstavateks klientideks — ilma reklaamieelarvet suurendamata. Selleks analüüsitakse, kus külastajad lahkuvad, miks nad ei võta ühendust, ja tehakse sihtotstarbelisi muudatusi sõnumis, struktuuris, laadimiskiiruses ja CTA-des. Isegi 1%-line konversioonimäära paranemine võib tähendada märkimisväärset käibetõusu. ScalingWebs mõõdab iga muudatuse mõju andmete põhjal.`)
};

const en_faq_a16 = /** @type {(inputs: Faq_A16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversion rate optimization (CRO) is the process of turning more website visitors into paying customers — without increasing ad spend. It involves analyzing where visitors drop off, why they don't contact you, and making targeted improvements to messaging, structure, loading speed, and CTAs. Even a 1% improvement in conversion rate can significantly increase revenue. ScalingWebs measures the impact of every change using data.`)
};

/**
* | output |
* | --- |
* | "Conversion rate optimization (CRO) is the process of turning more website visitors into paying customers — without increasing ad spend. It involves analyzing..." |
*
* @param {Faq_A16Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_a16 = /** @type {((inputs?: Faq_A16Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A16Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_a16(inputs)
	return en_faq_a16(inputs)
});